import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.initializeSelect2();
    this.setGoogleAnalyticsViewId();

    $(this.element).on('change', () => {
      this.setGoogleAnalyticsViewId()
    })
  }

  initializeSelect2() {
    $(this.element).find('.ga-integration-form__property-name select').select2({
      width: '100%',
      dropdownCssClass: "select2-ga-properties-dropdown",
      containerCssClass: "ga-select2-container",
      minimumResultsForSearch: Infinity,
      templateSelection: function(state) {
        if (!state.id) {
          return state.text;
        }

        const optgroupLabel = $(state.element).closest('optgroup').attr('label');
        return `${optgroupLabel} - ${state.text}`;
      }
    });
  }

  setGoogleAnalyticsViewId() {
    $(this.element).find('.ga-integration-form__property-name select').each(function() {
      const selectedOption = $(this).find('option:selected');
      const googleAnalyticsViewId = selectedOption.data('property-id');
      const googleAnalyticsViewIdField = $(this).closest('.ga-integration-form__site-info').find('.ga-integration-form__google-analytics-view-id');

      if (googleAnalyticsViewIdField.length) {
        googleAnalyticsViewIdField.val(googleAnalyticsViewId);
      }
    });
  }
}
